/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XInput from "vux/src/components/x-input/index.vue";
export default {
  components: {
    XInput: XInput
  },
  props: {
    title: {
      type: String,
      default: '扫码'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请扫码二维码/条码'
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false
    };
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    scan: function scan() {
      var _this = this;

      this.$DingTalk && this.$DingTalk.biz.util.scan({
        type: 'all',
        tips: '将二维码/条码放入框内，即可自动扫描',
        onSuccess: function onSuccess(_ref) {
          var text = _ref.text;
          _this.currValue = text;
        },
        onFail: function onFail(e) {
          console.log('scan error');
        }
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};